import { render, staticRenderFns } from "./FrictionViz.vue?vue&type=template&id=f10d2f76&scoped=true"
import script from "./FrictionViz.vue?vue&type=script&lang=js"
export * from "./FrictionViz.vue?vue&type=script&lang=js"
import style0 from "./FrictionViz.vue?vue&type=style&index=0&id=f10d2f76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10d2f76",
  null
  
)

export default component.exports